// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__WPOFs","modal":"Modal_modal__j8Efy","slide-down":"Modal_slide-down__2Lxjb"};